export const APP_NAME = 'KCDash';
export const APP_VERSION = '2.0.0';

export enum Role {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
  VIEWER = 'VIEWER',
}

export enum ServerState {
  OFFLINE = 'OFFLINE',
  STARTING = 'STARTING',
  ONLINE = 'ONLINE',
  STOPPING = 'STOPPING',
  RESTARTING = 'RESTARTING',
  CRASHED = 'CRASHED',
}

export enum ActionType {
  SERVER_START = 'SERVER_START',
  SERVER_STOP = 'SERVER_STOP',
  SERVER_RESTART = 'SERVER_RESTART',
  SERVER_FORCE_STOP = 'SERVER_FORCE_STOP',
  SERVER_CONFIG_UPDATE = 'SERVER_CONFIG_UPDATE',
  SERVER_FILE_CREATE = 'SERVER_FILE_CREATE',
  SERVER_FILE_UPDATE = 'SERVER_FILE_UPDATE',
  SERVER_FILE_DELETE = 'SERVER_FILE_DELETE',
  SERVER_FILE_UPLOAD = 'SERVER_FILE_UPLOAD',
  SERVER_COMMAND_EXECUTE = 'SERVER_COMMAND_EXECUTE',
  GAMEMODE_ACTIVATE = 'GAMEMODE_ACTIVATE',
  GAMEMODE_CREATE = 'GAMEMODE_CREATE',
  GAMEMODE_DELETE = 'GAMEMODE_DELETE',
  PLAYER_KICK = 'PLAYER_KICK',
  PLAYER_BAN = 'PLAYER_BAN',
  PLAYER_MESSAGE = 'PLAYER_MESSAGE',
  PLAYER_TELEPORT = 'PLAYER_TELEPORT',
  DATABASE_QUERY = 'DATABASE_QUERY',
  DATABASE_CREATE = 'DATABASE_CREATE',
  DATABASE_DELETE = 'DATABASE_DELETE',
  BACKUP_CREATE = 'BACKUP_CREATE',
  BACKUP_RESTORE = 'BACKUP_RESTORE',
  USER_CREATE = 'USER_CREATE',
  USER_UPDATE = 'USER_UPDATE',
  USER_DELETE = 'USER_DELETE',
  API_KEY_CREATE = 'API_KEY_CREATE',
  API_KEY_REVOKE = 'API_KEY_REVOKE',
}

export const DEFAULT_KCD_PORT = 7777;
export const DEFAULT_QUERY_PORT = 1404;
export const DEFAULT_INTERNAL_AGENT_PORT = 7790;

export const DEFAULT_MAX_PLAYERS = 32;
export const DEFAULT_SERVER_NAME = 'Kingdom Come: Deliverance II Dedicated Server';
export const DEFAULT_MAP_NAME = 'klaster';
export const DEFAULT_GAMEMODE = 'freeroam.lua';

export const ALLOWED_TEXT_EXTENSIONS = [
  '.lua',
  '.toml',
  '.json',
  '.yaml',
  '.yml',
  '.txt',
  '.cfg',
  '.conf',
  '.ini',
  '.env.example',
  '.md',
  '.xml',
  '.log',
] as const;

export const WS_EVENTS = {
  SERVER_STATUS: 'server:status',
  SERVER_METRICS: 'server:metrics',
  CONSOLE_LOG: 'console:log',
  CONSOLE_COMMAND: 'console:command',
  PLAYER_JOIN: 'player:join',
  PLAYER_LEAVE: 'player:leave',
  PLAYER_UPDATE: 'player:update',
  ERROR: 'system:error',
} as const;
